import {
  keepPreviousData,
  useQuery,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { clientsApi } from "@/api/clients/clients-api";
import type {
  ClientCreate,
  ClientUpdate,
} from "@/types/clients/api-types/client-types";

interface ClientSearchParams {
  page?: number;
  size?: number;
  first_name?: string;
  last_name?: string;
  staff_id?: number;
}

export const useGetClientsPaginated = (params: ClientSearchParams = {}) =>
  useQuery({
    queryKey: ["clients", params],
    queryFn: () => clientsApi.getAll(params),
    placeholderData: keepPreviousData,
  });

export const useCreateClient = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ClientCreate) => clientsApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["clients"] });
    },
  });
};

export const useUpdateClient = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: ClientUpdate }) =>
      clientsApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["clients"] });
    },
  });
};

export const useDeleteClient = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => clientsApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["clients"] });
    },
  });
};
